import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-internacion',
  templateUrl: './internacion.component.html',
  styleUrls: ['./internacion.component.css']
})
export class InternacionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
